import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AuthApiService } from 'src/app/services/auth-api.service';
import { SettingsService } from 'src/app/services/settings.service';
import { ResetPassword } from 'src/app/shared/models/users/reset-password';

@Component({
  selector: 'app-confirm-password-reset',
  templateUrl: './confirm-password-reset.component.html',
  styleUrls: ['./confirm-password-reset.component.scss'],
})
export class ConfirmPasswordResetComponent implements OnInit {
  public model: ResetPassword = new ResetPassword();
  public busy: boolean = false;
  public errorMsg: string = '';
  public showError: boolean = false;
  public showSuccess: boolean = false;
  public isRegistrationFlow = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authApi: AuthApiService,
    public settingsService: SettingsService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit(): void {
    this.settingsService.routeHidden = false;

    this.route.paramMap.subscribe((params) => {
      const passwordKey = params.get('password-key');
      if (passwordKey) {
        this.isRegistrationFlow = true;
        this.model.passwordKey = passwordKey;
      }
    });

    const email = this.route.snapshot.queryParamMap.get('email');
    if (email) {
      this.model.email = email;
    }
  }

  public SetNewPassword() {
    this.busy = true;
    this.showError = false;
    this.errorMsg = '';

    if (this.model.password !== this.model.confirmPassword) {
      this.showError = true;
      this.errorMsg = 'Passwords do not match.';
      this.busy = false;
      return;
    }

    if (this.isRegistrationFlow) {
      this.submitRegistrationPassword();
      return;
    }

    if (!this.model.email) {
      this.showError = true;
      this.errorMsg = 'Missing email address. Please restart the password reset flow.';
      this.busy = false;
      return;
    }

    this.recaptchaV3Service.execute('ResetPasswordEmail').subscribe(() => {
      this.authApi
        .resetPassword(this.model.email, this.model.otp?.trim(), this.model.password)
        .subscribe({
          next: () => this.onResetSuccess(),
          error: (error) => this.onResetError(error),
        });
    });
  }

  private submitRegistrationPassword(): void {
    if (!this.model.passwordKey) {
      this.showError = true;
      this.errorMsg = 'Invalid link, please contact support@dooya.co.za';
      this.busy = false;
      return;
    }

    this.recaptchaV3Service.execute('ResetPasswordEmail').subscribe(() => {
      this.authApi
        .setInitialPassword(
          this.model.passwordKey,
          this.model.password,
          this.model.confirmPassword,
        )
        .subscribe({
          next: () => this.onResetSuccess(),
          error: (error) => this.onResetError(error),
        });
    });
  }

  private onResetSuccess(): void {
    this.showSuccess = true;
    this.busy = false;

    setTimeout(() => {
      this.router.navigate(['login']);
    }, 4000);
  }

  private onResetError(error: any): void {
    this.showError = true;
    this.errorMsg = this.interpretError(error);
    this.busy = false;
  }

  private interpretError(error: any): string {
    if (typeof error?.error?.ErrorDetail === 'string' && error.error.ErrorDetail.length > 0) {
      return error.error.ErrorDetail;
    }
    if (typeof error?.error?.errorDetail === 'string' && error.error.errorDetail.length > 0) {
      return error.error.errorDetail;
    }
    if (typeof error?.error?.message === 'string' && error.error.message.length > 0) {
      return error.error.message;
    }
    if (error?.status === 401) {
      return 'Invalid or expired OTP. Please request a new code.';
    }
    return 'Unable to reset password. Please try again or contact support@dooya.co.za';
  }
}
